import {pipe} from 'ramda'

const isFuture = (x) => x && typeof x.fork === 'function'

const evolveAction = (action) => (suffix) => (payload) => ({
  ...action,
  payload,
  type: `${action.type}_${suffix}`,
})

export const handleFuture = ({dispatch, getState}) => (next) => (action) => {
  const dispatchAs = evolveAction(action)

  next(action)

  if (isFuture(action.payload)) {
    action.payload.fork(
      pipe(dispatchAs('FAILURE'), dispatch),
      pipe(dispatchAs('SUCCESS'), dispatch),
    )
  }
}

export const inject = (deps) => ({getState}) => (next) => (action) =>
  next(
    typeof action === 'function'
      ? action({
        ...deps,
        getState,
      })
      : action
  )



// WEBPACK FOOTER //
// ./src/store/middleware.js